import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useRemoveBankItem = (): UseMutationResult<
  unknown,
  unknown,
  { bankItemId: string }
> => {
  const queryClient = useQueryClient();
  const { treasureApi } = useTreasureApi(ApiKeys.Banking);

  const removeBankItem = async ({ bankItemId }: { bankItemId: string }) => {
    const { data } = await treasureApi().delete(
      `/accounts/items/${bankItemId}`,
    );

    return data;
  };

  return useMutation(removeBankItem, {
    onSuccess: () => {
      queryClient.invalidateQueries([ReactQueryKeys.BankAccountsV2]);
      queryClient.invalidateQueries([ReactQueryKeys.BankAccounts]);
      queryClient.invalidateQueries([ReactQueryKeys.ConnectedAccounts]);
    },
  });
};
